import {
  IAlarmCentralProps,
  IZoneAlarmCentralProps,
} from '../../../../../services/AlarmCentralService/types';
import { Grid2, Typography } from '@mui/material';
import { AlarmCentralEndpoint } from '../../../../../services/AlarmCentralService/enums';
import './AlarmCentralPhysical.css';
import { useSendBypassZones } from '../../../../../services/AlarmCentralService/Physical/hooks/useMutation';
import { useEffect, useState } from 'react';
import CardComponent from '../../../../../components/CardComponent/CardComponent';
import { IAlarmCentralIntelbrasStatusProps } from '../../../../../services/AlarmCentralService/Physical/Intelbras/IsecNetV2/types';

interface AlarmCentralPhysicalIntelbrasZonesProps {
  alarmCentral: IAlarmCentralProps;
  status: IAlarmCentralIntelbrasStatusProps;
}

const AlarmCentralPhysicalIntelbrasZones = ({
  alarmCentral,
  status,
}: AlarmCentralPhysicalIntelbrasZonesProps) => {
  const {
    mutateAsync: mutateSendBypassZonesAsync,
    isLoading: isLoadingSendBypassZonesAsync,
  } = useSendBypassZones();
  const [isLoadingZone, setIsLoadingZone] = useState<boolean[]>([]);

  // const renderDescriptionByStatus = (status: ZoneStatusJfl) => {
  //   switch (status) {
  //     case ZoneStatusJfl.DISABLED:
  //       return 'Desabilitada';
  //     case ZoneStatusJfl.INHIBITED:
  //       return 'Inibida';
  //     case ZoneStatusJfl.CLOSED:
  //       return 'Fechada';
  //     case ZoneStatusJfl.OPEN:
  //       return 'Aberta';
  //     case ZoneStatusJfl.NO_COMMUNICATION:
  //       return 'Sem comunicação';
  //     default:
  //       return '';
  //   }
  // };

  const createZoneListToUpdate = (zoneIndexToUpdate: number) => {
    const zones: IZoneAlarmCentralProps[] = [];
    status.isBypassZones.forEach((isBypassed, index) => {
      if (zoneIndexToUpdate == index) {
        zones.push({
          bypass: !isBypassed,
          zoneCode: index + 1,
        });
      } else {
        zones.push({
          bypass: isBypassed,
          zoneCode: index + 1,
        });
      }
    });
    return zones;
  };

  const inhibitedMessage = (isBypassed: boolean) =>
    isBypassed ? 'Clique para remover inibição' : 'Clique para inibir';

  useEffect(() => {
    const isLoading: boolean[] = [];
    for (let i = 0; i < alarmCentral.zoneQuantity; i++) isLoading.push(false);

    setIsLoadingZone(isLoading);
  }, [status, alarmCentral]);

  return (
    <>
      {[...Array(alarmCentral.zoneQuantity)].map((z, index) => {
        let zoneColor: '#fff' | 'red' | 'green' | 'rgb(47, 57, 87)' | undefined;

        if (status.isOpenZones[index]) zoneColor = 'green';
        else if (status.isBypassZones[index]) zoneColor = '#fff';
        else zoneColor = 'red';

        let zoneStatus = 'Fechada';
        if (status.isOpenZones[index]) zoneStatus = 'Aberta';
        else if (status.isBypassZones[index]) zoneStatus = 'Inibida';
        else if (!status.isUserCanUseThisZones[index])
          zoneStatus = 'Desabilitada';

        return (
          <Grid2 key={index} size={{ md: 4, xs: 12 }}>
            <CardComponent
              disabled={!status.isUserCanUseThisZones[index]}
              isLoading={isLoadingZone[index]}
              onClick={() => {
                mutateSendBypassZonesAsync({
                  endpoint:
                    AlarmCentralEndpoint.ALARM_CENTRAL_INTELBRAS_ISECNET_V2_ENDPOINT,
                  id: alarmCentral.id,
                  data: createZoneListToUpdate(index),
                });
                const isl = [...isLoadingZone];
                isl[index] = true;
                setIsLoadingZone(isl);
              }}
              additionalMessage={zoneStatus}
              representativeColor={zoneColor}
              tooltipMessage={inhibitedMessage(status.isBypassZones[index])}
            >
              <Typography sx={{ fontWeight: 'bold' }}>
                ZONA {index + 1}
              </Typography>
            </CardComponent>
          </Grid2>
        );
      })}
    </>
  );
};

export default AlarmCentralPhysicalIntelbrasZones;
